import { Container, Text } from 'pixi.js';
import { EventEmitter } from '.';
import { EasingFunction } from '../interface';
import { linear } from '../util';

abstract class DefaultCutAway extends Container {
  public emitter: EventEmitter;
  public easingFunction: EasingFunction = linear;
  public begin: number;
  public current: number;
  public end: number;
  public sceneWidth: number;
  public sceneHeight: number;
  public duration: number;
  public text: Text;

  constructor() {
    super();
    this.emitter = new EventEmitter();
    this.begin = 0;
    this.current = 0;
    this.end = 0;
    this.sceneWidth = 0;
    this.sceneHeight = 0;
    this.duration = 80;

    this.text = new Text('', {
      fontSize: 24,
      fontWeight: '700',
      fontFamily: 'ff-providence-sans-web-pro, sans-serif',
      fontStyle: 'normal',
      letterSpacing: -2,
      fill: '#ffffff',
      padding: 10,
    });
    this.sortableChildren = true;
    this.text.zIndex = Infinity;
    this.text.alpha = 0;
    this.text.anchor.set(1);
    this.addChild(this.text);
  }

  public update(elapsed: number): void {
    if (this.begin >= this.end) {
      this.current -= elapsed;

      this.text.alpha = (this.current - this.end) / (this.begin - this.end);

      if (this.current <= this.end) {
        this.emitter.emit('done');
        this.current = this.end;
      }
    } else if (this.begin <= this.end) {
      this.current += elapsed;

      this.text.alpha = (this.current - this.begin) / (this.end - this.begin);

      if (this.current >= this.end) {
        this.emitter.emit('done');
        this.current = this.end;
      }
    }
    this.text.x = this.sceneWidth - 20;
    this.text.y = this.sceneHeight - 20;
  }

  public setPercentage(currentValue: number, maxValue: number): void {
    this.text.text = `Loading ${Math.ceil((currentValue / maxValue) * 100)}% (${currentValue}/${maxValue})`;
  }

  public get value(): number {
    if (this.current > this.begin) {
      return this.easingFunction((this.current - this.begin) / (this.end - this.begin));
    } else if (this.current < this.begin) {
      return 2 - this.easingFunction((this.begin - this.current) / (this.begin - this.end));
    } else {
      return 1;
    }
  }

  public setSize(width: number, height: number): void {
    this.sceneWidth = width;
    this.sceneHeight = height;
  }

  public setFlow(easingFunction: EasingFunction, begin: number, end: number): void {
    this.current = begin;
    this.begin = begin;
    this.end = end;
    this.easingFunction = easingFunction;
  }
}

export default DefaultCutAway;
